import React, {Component} from 'react'
import {Container, Grid, Icon, Message, Visibility} from "semantic-ui-react";
import gdpr_flow from "./items/gdpr_flow.js";
import unicorn_flow from "./items/unicorns_items.js";
import Footer from "./components/footer.jsx";
import DawidHeader from "./components/header.jsx";
import './layout.css';
import {FORM_STYLE} from "./components/item.jsx";


const flows = [gdpr_flow, unicorn_flow];

export default class ErrorLayout extends Component {

    constructor(props) {
        super(props);
        this.state = {menuFixed: false}
    }


    stickTopMenu = () => this.setState({menuFixed: true});
    unStickTopMenu = () => this.setState({menuFixed: false});

    render() {

        const {errorInfo} = this.props;
        const widthCenterColumn = 10;
        return (
            <div>
                <style>{`
          html, body {
            background: #eee;
          }
        `}</style>
                <div id={"content"}>
                    <DawidHeader resetSession={() => window.location.reload()} logo={flows[0].logo}
                                 width={widthCenterColumn}/>

                    <Grid centered columns={1}>
                        <Grid.Column id="innerContent" width={widthCenterColumn}>
                            <Container fluid>
                                <Visibility className={"no-print"}
                                            onBottomPassed={this.stickTopMenu}
                                            onBottomVisible={this.unStickTopMenu}
                                            once={false}
                                >
                                </Visibility>

                                <Grid style={{clear: 'both', minHeight: '40vh'}}>
                                    <Grid.Row>
                                        <Grid.Column id="mainContent" mobile={16} tablet={16} computer={16}>
                                            <div style={FORM_STYLE}>
                                                <Message negative icon size='massive'>
                                                    <Icon name='bug'/>
                                                    <Message.Content>
                                                        <Message.Header>An unforeseen error occurred</Message.Header>

                                                    </Message.Content>
                                                </Message>
                                                <pre style={{
                                                    wordBreak: 'break-word',
                                                    whiteSpace: 'pre-line'
                                                }}> {errorInfo}</pre>
                                            </div>
                                        </Grid.Column>
                                    </Grid.Row>

                                </Grid>
                            </Container>
                        </Grid.Column>
                    </Grid>
                </div>
                <Footer/>
            </div>
        )
    }
}